<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="2"></HeaderNav>
    <!-- <Banner :banner="bannerList"  @click="loseFocus()"></Banner> -->
    <div class="intro_box cont840">
	<div class="title_2">公司简介</div>
	<hr class="hr_1">
    <div style="text-align: justify;">
        <img src="static/picture/intro_1.jpg" /></div>
    <h1 class="mt40 " style="text-align: justify;">
        日运（福建）贸易有限公司</h1>
    <p class="mt20 txt_in" style="text-align: justify;">
        成立于2018年1月，坐落于福建省福州市高新区。现有化妆品设计美学，化妆品教育培养，化妆品跨界合作等综合服务。目前为Luara、HOC TIME、LEWA、THE FOLKTALE等品牌提供服务，并启动全线落地服务，形成自身化妆品领域生态圈。</p>
    <p class="mt20 txt_in" style="text-align: justify;">
        LEWA株式会社从2009年开始踏上品牌建设，以LEWA面膜起步，逐步拓展产品链条及业务版块。拥有美容护肤领域的专业人才，合作的各大研究院均是专业领域突出的服务方。经过深入的研究、探索，逐步挑战品牌建设（Brand Creation system)供应链对接（supply chain system）、化妆品渠道跨界合作（cosmetic channel echo system)、化妆品定制（cosmetic customization）、化妆品投资服务（cosmetic investment service）等多元专业领域。</p>

    </div>
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banner from '../../components/Banner.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      id:'',
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
      bannerList: [
        {url:'static/picture/luara_banner1.jpg'},
        {url:'static/picture/luara_banner2.jpg'},
        {url:'static/picture/luara_banner3.jpg'},
      ],
    };
  },
  created() {

  },
  methods: {
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
  }
};
</script>
<style scoped>
@media (min-width: 1110px){
    .cont840 {
        width: 840px;
        margin: 0 auto;
    }
}
@media (min-width: 768px){
	.nav li {
		padding: 0 15px;
	}
	.pc_img{
		display: none;
	}
	.wap_img{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: block;
	}
}


@media (min-width: 1110px) {
	.pc_img{
		display: block;
	}
	.wap_img{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: none;
	}
}
/*------------about_intro.html  start----------------*/
.intro_box{
	overflow: hidden;
	padding: 40px 0 60px;
}
.intro_box img{
	display: block;
	margin: 0 auto;
	max-width: 100%;
}
.intro_box h1{
	color: #2e2e2e;
	font-size: 18px;
	font-family: Font_Medium;
    font-weight: 550;
}
.intro_box p{
	color: #2e2e2e;
	line-height: 26px;
	margin: 0;
	font-size: 15px;
	font-family: Font_Light;
}
.intro_box dl{
	width: 100%;
	overflow: hidden;
}
.intro_box dl dt{
	float: left;
	width: 245px;
}
.intro_box dl.dl_basic dt{
	width: 560px;
}
.intro_box dl.dl_100 dt{
	float: inherit;
	width: 100%;
}
.intro_box dl dt img{
	max-width: 100%;
}

.intro_box dl dd{
	float: right;
	width: calc(100% - 270px);
	color: #2e2e2e;
}
.intro_box dl.dl_basic dd{
	width: calc(100% - 580px);
}
.intro_box dl.dl_100 dd{
	float: inherit;
	width: 100%;
}
.intro_box dl dd h2{
	margin-top: 0;
	font-size: 15px;
	font-family: Font_Medium;
}
.intro_box dl dd p{
	font-size: 15px;
	font-family: Font_Light;
}
.intro_box dl dd h3{
	margin-top: 0;
	font-size: 18px;
	font-family: Font_Medium;
	overflow: hidden;
}
.intro_box dl dd span{
	display: inline-block;
	width: 400px;
	text-align: center;
	height: 54px;
	line-height: 50px;
	margin-right: 130px;
	color: #2e2e2e;
}
.intro_box dl dd i{
	letter-spacing: 1px;
	font-style: normal;
	font-size: 13px;
	font-family: Font_Medium;
}
.intro_box dl dd em{
	width: 32px;
	height: 30px;
	display: block;
    float: left;
	/* background: url(../../static/image/addr.png) no-repeat 0px 0px; */
}
.intro_box dl dd a{
	float: right;
	color: #2e2e2e;
	font-size: 12px;
    font-family: Font_Medium;
	margin-top: 20px;
	padding-right: 15px;
	/* background: url(../images/more_jt.png) no-repeat right center; */
}
.intro_box dl dd a.a_link{
	float: inherit;
    font-family: Font_Medium;
	margin-top: 0;
	background: none;
}
/*------------about_intro.html  end----------------*/
</style>


// WEBPACK FOOTER //
// src/view/plus/company.vue